import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, getFileDownloadHeaders, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/utils/RtkQueryUtils";
import { downloadFile } from "../../../helpers/utils/FileUtils";
import { getFileName, serialize, showToast } from "../../../helpers/utils/Utils";


export const fulFillmentPricingApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchFulFillmentPricing: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ajax/fulfillment-pricing?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['fulfillmentPricing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getFulfillmentPricingById: build.query({
            query: (regionId) => {
                return {
                    url: `/ajax/fulfillment-pricings/${regionId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['fulfillmentPricingById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createFulfillmentPricing: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create-or-update-fulfillment-pricing`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['fulfillmentPricing'],
            async onQueryStarted(requestBody, { queryFulfilled }) {
                const action = requestBody?.id ? "Updated" : "Created";
                await handleQueryErrorAndSuccess(queryFulfilled, action, "Fulfillment Pricing");
            },
        }),


        updateFulfillmentPricing: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/fulfillment-pricings/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['fulfillmentPricing', 'fulfillmentPricingById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Fulfillment Pricing");
            },
        }),

        deleteFulfillmentPricingById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-by-fulfillment-pricing-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['fulfillmentPricing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Fulfillment Pricing");
            },
        }),

        exportFulfillmentPricingData: build.query({
            query: (query) => {
                return {
                    url: `/export/fulfillment-pricing`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => Promise<Blob> }) => {
                        const blob = await response.blob();

                        if (blob.size > 0) {
                            downloadFile(blob, getFileName("fulfillmentPricing"));
                            return { success: true };
                        } else {
                            showToast("No data found.");
                            return { success: false, message: "No data found." };
                        }
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

    })
})

export const {
    useSearchFulFillmentPricingQuery,
    useLazySearchFulFillmentPricingQuery,
    useCreateFulfillmentPricingMutation,
    useDeleteFulfillmentPricingByIdMutation,
    useLazyExportFulfillmentPricingDataQuery

} = fulFillmentPricingApi